var map = {
	"./2factor.png": 8458,
	"./apple-logo.svg": 1620,
	"./audio.svg": 3823,
	"./clinic.svg": 3179,
	"./close-circle.png": 812,
	"./close-circle.svg": 7594,
	"./coming-icon.svg": 3444,
	"./company-icon-01.svg": 9946,
	"./company-icon-02.svg": 1321,
	"./company-icon-03.svg": 5928,
	"./company-icon-04.svg": 8759,
	"./company-icon-05.svg": 4934,
	"./company-icon-06.svg": 3157,
	"./company-icon-07.svg": 548,
	"./company-icon-08.svg": 3683,
	"./company-icon-09.svg": 9042,
	"./company-icon-10.svg": 3048,
	"./delete.svg": 4738,
	"./drag-drop.svg": 1641,
	"./emoj-icon-01.svg": 7148,
	"./emoj-icon-02.svg": 2495,
	"./emoj-icon-03.svg": 7742,
	"./emoj-icon-04.svg": 3089,
	"./emoj-icon-05.svg": 288,
	"./emoji-smile.svg": 1824,
	"./facebook-logo.svg": 4981,
	"./flag-01.svg": 4623,
	"./flag-02.svg": 2300,
	"./flag-03.svg": 845,
	"./flag-04.svg": 6914,
	"./folder-minus.svg": 6828,
	"./folder.svg": 4219,
	"./gateway-01.svg": 449,
	"./gateway-02.svg": 8706,
	"./gateway-03.svg": 8099,
	"./google-icon.svg": 8648,
	"./google-logo.svg": 734,
	"./half-circle.svg": 3421,
	"./heart.svg": 5685,
	"./hi.svg": 5586,
	"./image.svg": 9682,
	"./integration-01.svg": 8717,
	"./integration-02.svg": 894,
	"./integration-03.svg": 3471,
	"./integration-04.svg": 7584,
	"./integration-05.svg": 9825,
	"./integration-06.svg": 4786,
	"./like.svg": 9358,
	"./mail-01.svg": 1350,
	"./mail-02.svg": 3125,
	"./mail-03.svg": 5876,
	"./pause.svg": 4299,
	"./pause1.svg": 3152,
	"./payment-01.svg": 1817,
	"./payment-02.svg": 6730,
	"./payment-03.svg": 5787,
	"./payment-04.svg": 3636,
	"./payment-05.svg": 8357,
	"./payment-06.svg": 9222,
	"./payment-07.svg": 6759,
	"./payment-08.svg": 1280,
	"./payment-09.svg": 4081,
	"./payment-10.svg": 1499,
	"./pdf-02.svg": 9150,
	"./pdf.svg": 7603,
	"./play-01.svg": 747,
	"./preference-01.svg": 5860,
	"./preference-02.svg": 423,
	"./preference-03.svg": 6598,
	"./preference-04.svg": 2985,
	"./preference-05.svg": 1240,
	"./preference-06.svg": 1979,
	"./preference-07.svg": 1610,
	"./preference-08.svg": 8285,
	"./preference-09.svg": 8812,
	"./preference-10.svg": 8906,
	"./preference-11.svg": 2779,
	"./preference-12.svg": 4712,
	"./scanner.svg": 4075,
	"./scanners.svg": 194,
	"./smile-chat.svg": 8220,
	"./storage-icon-01.svg": 4908,
	"./storage-icon-02.svg": 3935,
	"./trash-bin.svg": 1495,
	"./video.svg": 9504,
	"./voice.svg": 5903,
	"./xls.svg": 958,
	"./zip.svg": 2776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9945;